import { render, staticRenderFns } from "./TransferRx.vue?vue&type=template&id=e0cec32e&scoped=true&"
import script from "./TransferRx.vue?vue&type=script&lang=js&"
export * from "./TransferRx.vue?vue&type=script&lang=js&"
import style0 from "./TransferRx.vue?vue&type=style&index=0&id=e0cec32e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cec32e",
  null
  
)

export default component.exports